import { render, staticRenderFns } from "./ViewTakeLeave.vue?vue&type=template&id=397b67cb&scoped=true"
import script from "./ViewTakeLeave.vue?vue&type=script&lang=js"
export * from "./ViewTakeLeave.vue?vue&type=script&lang=js"
import style0 from "./ViewTakeLeave.vue?vue&type=style&index=0&id=397b67cb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397b67cb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('397b67cb')) {
      api.createRecord('397b67cb', component.options)
    } else {
      api.reload('397b67cb', component.options)
    }
    module.hot.accept("./ViewTakeLeave.vue?vue&type=template&id=397b67cb&scoped=true", function () {
      api.rerender('397b67cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/parentdiary/ViewTakeLeave.vue"
export default component.exports